export class ReferringPhysicianInstituteEditInfo {
    public Name: string;
    public Id: number;
}
